const apps = [

  //----- 12PACK -----//
  {
    slug: '12Pack',
    name: '12Pack',
    logo: '/12Pack/12packlogo_transparent.png',
    tagline: 'Say goodbye to forgotten socks and last-minute stress — your luggage packing app is now live!',
    features: [
       '✈️ Create travels to attach your luggage lists to',
      '📋 Build reusable luggage templates so you never start from scratch',
      '🗂 Sort luggage by category for a clear, organized view',
      '👥 Add participants and assign luggage items to one or more people',
      '✅ Check off items as you pack, so nothing is left behind',
    ],
    story: 'Pack smarter, so nothing (and no one) is left behind 😉',
    storeLinks: {
      appStore: 'https://apps.apple.com/be/app/12pack/id6746409852?l=fr-FR',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.jellybean.checkit_flutter&hl=nl',
      webApp: 'https://1-2-pack.vercel.app/',
    },
    privacy: {
      dataStored: ['Your first name', 'Your last name', 'Your email address'],
      storage: 'The data is stored in Firebase, a Back-end-as-a-service platform from Google.',
      services: '12Pack uses following Firebase services: Authentication and Databases',
    },
    accountDeletion: [
      'Log into the app',
      'In the bottom navigation, click on Profile',
      'On your profile page, click on the red button "Delete account"',
    ],
    screenshots: [
      { src: '12Pack/Travels%20overview.PNG', alt: 'Travels overview screen' },
      { src: '12Pack/Travels%20luggages%20overview.PNG', alt: 'Travels luggage overview screen' },
      { src: '12Pack/Participants%20overview.PNG', alt: 'Participants overview screen' },
      { src: '12Pack/Templates%20overview.PNG', alt: 'Templates overview screen' },
      { src: '12Pack/Template%20luggages%20overview.PNG', alt: 'Templates luggage overview screen' },
    ],
  },

  //----- 12STUDY -----//
  {
    slug: '12Study',
    name: '12Study',
    logo: '/12Study/12studylogo_transparent.png',
    tagline: 'Your smart study companion!',
    features: [
      'Organize your study by creating categories',
      'Build smart flashcards',
      'Focussed study sessions with randomized cards practice',
      'Reinforce if you need more practice',
    ],
    story: 'Flip, Learn, Master!',
    storeLinks: { webApp: 'https://jellybeanstudios.be/12study' },
    privacy: {
      dataStored: ['Your first name', 'Your last name', 'Your email address'],
      storage: 'The data is stored in Firebase, a Back-end-as-a-service platform from Google.',
      services: '12Study uses following Firebase services: Authentication and Databases',
    },
    accountDeletion: [
      'Log into the app',
      'Click on Settings at top right of the page',
      'In the Danger zone, click on "Suppress Account"',],
    screenshots: [
      { src: '12Study/Categories%20overview.PNG', alt: 'Category overview' },
      { src: '12Study/Add%20new%20card%20to%20category.PNG', alt: 'Add new card to category' },
      { src: '12Study/Cards%20overview.PNG', alt: 'Cards overview' },
      { src: '12Study/Study%20question.PNG', alt: 'Study question' },
      { src: '12Study/Study%20answer.PNG', alt: 'Study answer' },
     { src: '12Study/Study%20result.PNG', alt: 'Study result' }],
  },
];

export default apps;
